import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { CommonFormComponent } from '../../../public-api';
import { CustomValidators } from '../../utilities/customer_validators';
import { ValidatorFn, Validators } from '@angular/forms';
import { I18nService } from '../../services/i18n.service';
import { AuthenticationService } from '../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { App_Routes } from '../../enums/router.enum';
import { FormKey } from '../../enums/i18.enum';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { LP_UI_CONFIG } from '../../core/tokens';
import { UiService } from '../../../public-api';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
export interface FormField {
  controlName: any;
  label: any;
  controlType: 'text' | 'number' | 'select' | 'password';
  placeholder?: any;
  validators?: ValidatorFn[];
  options?: any[]; // Required for 'select' type
  initialValue?: any;
}

@Component({
  selector: 'app-change-password',
  imports: [CommonFormComponent, NzIconModule, NzImageModule],
  templateUrl: './change-password.html',
  styleUrl: './change-password.scss',
})
export class ChangePassword implements OnInit {
  success = signal<boolean>(false);
  error = signal<boolean>(false);
  token: any;
  authorized = false;
  authorizing = false;
  isSuccessfullySubmitted = false;
  public cfg = inject(LP_UI_CONFIG);
  private route = inject(ActivatedRoute);
  public i18n = inject(I18nService);
  private auth = inject(AuthenticationService);
  private router = inject(Router);
  public changePasswordForm = new CommonFormComponent();
  public ui = inject(UiService);
  isMobile = computed(() => this.ui.IsMobile());
  isFromEmail = computed(
    () =>
      (window.location.pathname.startsWith('/em/changepw/') &&
        window.location.pathname.split('/em/changepw/')[1]?.length > 20) ||
      (window.location.pathname.startsWith('/ia/changepw/') &&
        window.location.pathname.split('/ia/changepw/')[1]?.length > 20)
  );
  formConfiguration = computed<FormField[]>(() => [
    // Current Password is not req is user is coming from Email
    ...(this.isFromEmail()
      ? []
      : [
          {
            controlName: FormKey.CurrentPassword,
            label: this.i18n.langString(FormKey.LabelCurrentPassword),
            controlType: 'password' as const,
            placeholder: this.i18n.langString(FormKey.LabelCurrentPassword),
            initialValue: null,
            validators: [Validators.required],
          },
        ]),
    {
      controlName: FormKey.Password,
      label: this.i18n.langString(FormKey.LabelNewPassword),
      controlType: 'password' as const,
      placeholder: this.i18n.langString(FormKey.LabelNewPassword),
      initialValue: null,
      validators: [...CustomValidators.strongPassword],
    },
    {
      controlName: FormKey.ConfirmPassword,
      label: this.i18n.langString(FormKey.LabelRepeatPassword),
      controlType: 'password' as const,
      placeholder: this.i18n.langString(FormKey.LabelRepeatPassword),
      initialValue: null,
      validators: [Validators.required],
    },
  ]);
  get isLoggedIn(): boolean {
    return this.auth.isLoggedIn();
  }

  get credentialLogin(): boolean {
    return this.cfg.credentialLogin;
  }

  get portalLogin(): boolean {
    return this.cfg.portalLogin;
  }

  get debugMode(): boolean {
    return this.cfg.debugMode;
  }

  ngOnInit() {
    if (!this.isLoggedIn) {
      this.route.params.subscribe((params) => {
        this.token = GLOBAL_CONSTANT.EMPTY_STRING + params['token'];
        this.checkAuthorization();
      });
    }
  }

  checkAuthorization() {
    this.authorized = false;
    this.authorizing = true;
    this.auth.checkForgotPasswordToken(this.token).subscribe(
      (isAuth) => {
        this.authorized = isAuth;
        this.authorizing = false;
      },
      (error) => {
        console.error(error);
        this.authorized = false;
        this.authorizing = false;
      }
    );
  }

  setNewPassword(formData: { currentPassword: string; password: string }) {
    // if (!this.authorized && !this.isLoggedIn) return;
    this.success.set(false);
    this.error.set(false);

    if (this.isLoggedIn) {
      this.auth.setNewPasswordViaSettings(formData.currentPassword, formData.password).subscribe(
        (res) => {
          if (res) {
            this.success.set(true);
            this.isSuccessfullySubmitted = true;
          } else {
            this.error.set(true);
            this.isSuccessfullySubmitted = false;
          }
        },
        (error) => {
          console.error(error);
          this.error.set(true);
        }
      );
    } else {
      this.auth.setNewPasswordViaEmail(this.token, formData.password).subscribe(
        (res) => {
          if (res) {
            this.success.set(true);
            this.isSuccessfullySubmitted = true;
          } else {
            this.error.set(true);
            this.isSuccessfullySubmitted = false;
          }
          this.router.navigate([App_Routes.LOGIN, App_Routes.PW_CHANGED]);
        },
        (error) => {
          console.error(error);
          this.error.set(true);
        }
      );
    }
  }
}
